<template lang="pug">
transition(name="map-cover")
  .l-map-cover(@click="clickCover",v-show="store.ui.state.article.show")
.l-map(:style="styleObject")
  MapKumo
  MapLotus
  MapRenderer
    //- シーンをv-forにて
    MapScene(
      v-for="maptype in store.api.state.maptypePattern"
      :maptype="maptype"
    )
      //- 背景
      MapBg(
        :maptype="maptype"
      )

      //- jsomからの固定オブジェクトをv-forにて
      MapItem(
        v-for="mapdata in store.api.state.mapdata[maptype]"
        v-if="!store.ui.state.tutorial.show"
        :maptype="maptype"
        :mapdata="mapdata"
      )

      //- apiからのspotピンをv-forにて
      MapItem(
        v-for="mapdata in store.api.state.spotsEveryMapType[maptype]"
        v-if="!store.ui.state.tutorial.show"
        :maptype="maptype"
        :mapdata="mapdata"
      )

      

</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-map-cover
  pos(0,0,51)
  wh()
  background-color rgba(114,114,114,0.3)
.l-map
  pos()
  wh()
  overflow hidden
  // background-color #CCC
  // transition background-color 200ms


/** transition */

.map-cover-enter-active
  transition opacity 600ms
.map-cover-leave-active
  transition opacity 200ms
  
.map-cover-enter-from,
.map-cover-leave-to
  opacity 0 !important

.map-cover-enter-to,
.map-cover-leave-from
  opacity 1 !important


</style>


<script>
import { defineComponent, computed, ref, onMounted, reactive } from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'
import MapScene from './MapScene'
import MapRenderer from './MapRenderer'
import MapItem from './MapItem'
import MapBg from './MapBg'
import MapKumo from './MapKumo'
import MapLotus from './MapLotus'

export default defineComponent({
  name:'Map',

  components:{MapRenderer,MapScene,MapItem,MapBg,MapKumo,MapLotus},

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()

    onMounted(()=>{
    })

    const clickDummy = () =>{
      router.push('/article/1235')
    }
    const clickCover = () =>{
      router.push('/')
    }

    const styleObject = computed(()=>{
      return {
        backgroundColor:store.ui.state.seasonColor(store.ui.state.season,store.ui.state.hotoke)
      }
    })

    return{
      clickCover,
      clickDummy,
      styleObject,
      store
    }
  }
})
</script>
